module.exports = __webpack_public_path__ + "img/lr-cb66-r1.63fa337a.gif";